import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import store from "./store";
import { Provider } from 'react-redux'

// Array.prototype.at not available in (Mobile) Safari
import "./shims/ArrayAt";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
